/* The one image picker — Marque's logo and the welcome page's photo (D-87). The file goes to
   POST /v1/app/media as is; the answer's `url` is what the screen stores (brand.logoUrl, look.photo).
   The API's own French sentence shows on a refusal (413 too large, 415 wrong format), and nothing
   is stored until the upload answered. */
import { useRef, useState, type ReactNode } from 'react'
import { ApiError, uploadMedia } from '@/lib/api'

export const IMAGE_TYPES = 'image/jpeg,image/png,image/webp'

export default function ImageDrop({ label, onUploaded, testid, children }: {
  label: string
  onUploaded: (url: string, name: string) => void
  testid?: string
  children?: ReactNode
}) {
  const input = useRef<HTMLInputElement>(null)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [over, setOver] = useState(false)

  const send = async (file: File | undefined) => {
    if (!file || busy) return
    setBusy(true); setError(null)
    try {
      const m = await uploadMedia(file)
      onUploaded(m.url, file.name)
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'L’envoi n’a pas abouti. Réessayez dans un instant.')
    } finally {
      setBusy(false)
      if (input.current) input.current.value = ''
    }
  }

  return (
    <div style={{ display: 'grid', gap: 6, flex: 1, minWidth: 200 }} data-testid={testid}>
      <button type="button" className="in" disabled={busy} aria-busy={busy}
        style={{ borderStyle: 'dashed', textAlign: 'center', padding: 12, cursor: busy ? 'progress' : 'pointer', background: over ? 'var(--bmr-selected)' : undefined }}
        onClick={() => input.current?.click()}
        onDragOver={e => { e.preventDefault(); setOver(true) }}
        onDragLeave={() => setOver(false)}
        onDrop={e => { e.preventDefault(); setOver(false); void send(e.dataTransfer.files[0]) }}>
        {busy ? 'Envoi de l’image…' : children ?? label}
      </button>
      <input ref={input} type="file" accept={IMAGE_TYPES} hidden aria-label={label} onChange={e => void send(e.target.files?.[0])} />
      {error && <p role="alert" className="f-help" style={{ margin: 0, color: 'var(--bmr-danger)' }}>{error}</p>}
    </div>
  )
}
